import styled from 'styled-components';
import { Container, getToken, Stack, ZIndex } from '@optimus-web/core';

const Footer = styled(Container)`
    background-color: ${getToken('backgroundStaticRaised')};
    border-top: ${getToken('borderWidth100')}px solid ${getToken('borderStaticSecondary')};
    box-sizing: border-box;
`;

interface PageFooterProps {
    children: React.ReactNode;
}

export const PageFooter = ({ children }: PageFooterProps) => (
    <Footer
        position="fixed"
        bottom="0"
        left="0"
        width="100%"
        padding={['200', '300']}
        zIndex={ZIndex.Highest}
        as="footer"
    >
        <Stack distribution="space-between">{children}</Stack>
    </Footer>
);
